import * as React from 'react';

import * as styles from './styles.css';

interface IResidentialComplexCardWrapperProps {
  children: React.ReactNode;
}

export function ResidentialComplexCardWrapper({ children }: IResidentialComplexCardWrapperProps) {
  return <div className={styles['container']}>{children}</div>;
}
